import { flatMap } from 'lodash';

import WithdrawalCommands from '@app/dev/terminal/components/withdrawal/commands';
import { resolveWithdrawalError } from '@app/dev/terminal/components/withdrawal/errors';
import ToastWrapper from '@common/helpers/toastWrapper';
import Config from '@skin_config';

const isV1 = () => !!Config.main.useWithdrawV1;

class WithdrawalService {
  /**
   * Returns a normalized list of betshop options: `[{ name, value }, ...]`
   * where `value` is what should be passed to `createCashRequest` (shopId for
   * v1, office id for v2).
   */
  static getBetShopList = async () => {
    try {
      if (isV1()) {
        const data = await WithdrawalCommands.getBetshopListV1();
        if (!data) return [];

        const shopsField = data.details?.fields?.find(({ name }) => name === 'shopId');
        if (!shopsField) return [];

        return Object.values(shopsField.value.options).map((item) => ({
          name: item.text,
          value: item.value,
        }));
      }

      const data = await WithdrawalCommands.getBetshopListV2();
      if (!data) return [];

      const cities = data.result?.cities || [];
      return flatMap(cities.map(({ betshops }) => betshops || [])).map(({ address, id }) => ({
        name: address,
        value: id,
      }));
    } catch {
      return [];
    }
  }

  static getBalance = async () => {
    const data = await WithdrawalCommands.getClientBalance();

    if (!data) return null;

    return data.details;
  }

  static createCashRequest = async (amount, betshopValue) => {
    const data = isV1()
      ? await WithdrawalCommands.cashWithdrawalRequestV1(amount, betshopValue)
      : await WithdrawalCommands.cashWithdrawalRequestV2(amount, betshopValue);

    if (data.result !== 0) {
      ToastWrapper("error", resolveWithdrawalError(data.details));
      return null;
    }
    return data.details;
  }

  static getHistory = async (start, end) => {
    const data = await WithdrawalCommands.getWithdrawalHistory(start, end);

    if (data.result !== 0) {
      ToastWrapper("error", data.details);
    }
    return data.details;
  }
}
export default WithdrawalService;
